<div class="login-background">
  <mat-card style="align-self: center;justify-self: center; top:6em;">
    <mat-card-header style="justify-content: center">
      <div class="example-header-image" mat-card-avatar></div>
      <h2 style="right: 1.5em;
      color:#000;
    align-self: center;
    position: relative;
    top: 0.3em;">Job Files</h2>
    </mat-card-header>
    <mat-card-content style="background: #FFF;">
      <form
        novalidate
        autocomplete="off"
        #loginForm="ngForm"
        (ngSubmit)="login()">

        <button style="width: 100%" mat-raised-button class="mat-primary" color="primary" [disabled]="loginForm.invalid" type="submit"
        >Login</button>

      </form>
      <div class="need-help links text-center">
        Need Help? please log a ticket on  <a target= "__blank" class="signin" href="https://tke.service-now.com">ServiceNow</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
